export const CREATE_QUESTION_REQUEST = '@quiz/CREATE_QUESTION_REQUEST';
export const CREATE_QUESTION_SUCCESS = '@quiz/CREATE_QUESTION_SUCCESS';
export const FAILURE = '@quiz/FAILURE';
